import {
    Accordion,
    AccordionItem,
    AccordionTrigger,
    AccordionContent,
} from "@/components/ui/accordion";

const ITEMS = [
    {
        q: "Wir sind keine IT-Firma. Wie aufwendig ist die Einführung?",
        a: "Fast gar nicht – für Sie. Wir schließen Kirenzo an Ihre bestehenden Systeme an (E-Mail, Telefon, Kalender) und richten alles ein. Ihr Team muss kein neues Programm lernen, es bekommt nur weniger Routinearbeit auf den Tisch.",
    },
    {
        q: "Ersetzt die KI meine Mitarbeiter?",
        a: "Nein. Kirenzo nimmt Ihrem Team die wiederkehrenden Standardaufgaben ab – die Arbeit, die niemand vermissen wird. Alles, was Erfahrung und Urteilsvermögen braucht, landet weiterhin bei Ihren Leuten. Nur eben ohne die ständigen Unterbrechungen.",
    },
    {
        q: "Was passiert mit unseren Kundendaten?",
        a: "Die Verarbeitung läuft DSGVO-konform auf Servern in Deutschland. Ihre Daten werden nicht verkauft oder für fremde Zwecke genutzt. Die Details klären wir transparent im Erstgespräch – inklusive Auftragsverarbeitungsvertrag.",
    },
    {
        q: "Und wenn die KI mal falsch antwortet?",
        a: "Die KI beantwortet nur Standardfragen – mit Antworten, die Sie vorher freigegeben haben. Alles Unklare oder Komplexe geht automatisch an einen Menschen im Team, inklusive Zusammenfassung. Sie behalten die Kontrolle darüber, was automatisiert beantwortet wird.",
    },
    {
        q: "Ab wann lohnt sich das für uns?",
        a: "Als Faustregel: Wenn Ihr Team täglich mehrfach dieselben Anfragen beantwortet, Daten von Hand überträgt oder Termine per Mail abstimmt, lohnt es sich. Unsere Kunden haben typischerweise 2 bis 20 Mitarbeiter – die Branche ist zweitrangig, der Prozess entscheidet.",
    },
    {
        q: "Was kostet Kirenzo?",
        a: "Das hängt davon ab, welche Prozesse wir automatisieren – es gibt kein Einheitspaket von der Stange. In der kostenlosen Demo schauen wir uns Ihre Abläufe an und nennen Ihnen danach einen konkreten, festen Rahmen. Ohne versteckte Kosten.",
    },
];

export const Faq = () => (
    <section id="faq" className="py-20 lg:py-28 border-t border-white/[0.06] scroll-mt-16" aria-labelledby="faq-heading">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-5 gap-10 lg:gap-16">
            <div className="lg:col-span-2">
                <p className="font-mono-label text-xs uppercase tracking-[0.2em] text-emerald-400">Häufige Fragen</p>
                <h2 id="faq-heading" className="mt-4 text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-white">
                    Was uns Inhaber vor der Demo fragen.
                </h2>
                <p className="mt-4 text-base sm:text-lg text-[#9CA3AF] leading-relaxed">
                    Ehrlich beantwortet – ohne Kleingedrucktes. Ihre Frage ist nicht dabei?{" "}
                    <a href="mailto:info@kirenzo.de" data-testid="faq-email-link" className="text-emerald-400 hover:text-emerald-300 underline underline-offset-4">
                        Schreiben Sie uns direkt.
                    </a>
                </p>
            </div>
            <div className="lg:col-span-3">
                <Accordion type="single" collapsible data-testid="faq-accordion" className="w-full">
                    {ITEMS.map((item, i) => (
                        <AccordionItem
                            key={i}
                            value={`faq-${i}`}
                            data-testid={`faq-item-${i + 1}`}
                            className="border-white/[0.08]"
                        >
                            <AccordionTrigger
                                data-testid={`faq-trigger-${i + 1}`}
                                className="text-base font-medium text-white hover:text-emerald-300 hover:no-underline py-5"
                            >
                                {item.q}
                            </AccordionTrigger>
                            <AccordionContent data-testid={`faq-content-${i + 1}`} className="text-sm text-[#9CA3AF] leading-relaxed">
                                {item.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </div>
        </div>
    </section>
);
